export const PATHS = {
  home: "/",
  library: "/library/",
  pricing: "/pricing/",
  unsubscribe: "/unsubscribe/",
  login: "/login/",
  checkout: "/checkout/",
  signup: "/signup/",
  forgotPassword: "/forgot/",
  privacy: "/privacy/",
  terms: "/terms/",
  imprint: "/imprint/",
  account: "/account/",
} as const;
